import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../utils/page";
import ProfileComponent from "../../Components/ProfileComponent/ProfileComponent";
import { toast } from "react-toastify";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
// import Croper from "../../Components/ProfileComponent/Croper"

const Profile = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const FetchGoogleImage = GetLocalStorageParsed("googleImage");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const profileImageRed = useRef(null);
  const [loginToken, setLoginToken] = useState(FetchToken || null);

  const [profileData, setProfileData] = useState([]);
  const [imageUrl, setImageUrl] = useState();
  const [imageUrlHeader, setImageUrlHeader] = useState();

  const [loading, setLoading] = useState();
  const [editData, setEditData] = useState(false);
  const [buisnessCheck, setBuisnessCheck] = useState();
  const [vendorBannerAnalytic, setVendorBannerAnalytic] = useState();
  const [bannerUrl, setBannerUrl] = useState();
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [updateIndex, setUpdateIndex] = useState();
  const [hideButton, setHideButton] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [BannerData, setBannerData] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const handleCloseBanner = () => {
    setShowUpdate(false);
  };

  const [bannerDataImage, setBannerDataImage] = useState();
  const [profileImage, setProfileImage] = useState(null);

  // show state for address
  const [show, setShow] = useState(false);
  const [DeliveryAddressList, setDeliveryAddressList] = useState([]);
  const [PrefiledData, setPrefiledData] = useState("");
  const [profileChange, setProfileChange] = useState(false);
  const [image, setImage] = useState(null);
  const [bannerUpdate, setBannerUpdate] = useState(null);

  const [formData, setFormData] = useState({
    name: "",


    email: "",
    address: "",
    phoneNo: "",
    businessName: "",
    gstno: "",
  });
  const fileBannerRef = useRef(null);

  const [croppedImage, setCroppedImage] = useState(null);
  const [bannerUpdateImage, setBannerUpdateImage] = useState(null);
  const [clickedBannerData, setClickedBannerData] = useState();

  const [bannerImageData, setBannerImageData] = useState();
  const [businessDetail, setBusinessDetail] = useState({
    BusinessName: "",
    BusinessGSTNo: "",
    BusinessImage: "",
  });
  const [Address, setAddress] = useState({
    name: "",
    mobile: "",
    pincode: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    landmark: "",
    altPhone: "",
  });
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setPrefiledData("");
    setAddress({
      name: "",
      mobile: "",
      pincode: "",
      address: "",
      locality: "",
      city: "",
      state: "",
      landmark: "",
      altPhone: "",
    });
    setShow(true);
  };
  const validateAddress = () => {
    if (!Address.mobile) {
      toast.error("Mobile number is required");
      return false;
    }
    if (!Address.pincode) {
      toast.error("Pincode is required");
      return false;
    }
    if (!Address.address) {
      toast.error("Address is required");
      return false;
    }
    if (!Address.locality) {
      toast.error("Locality is required");
      return false;
    }
    if (!Address.city) {
      toast.error("City is required");
      return false;
    }
    if (!Address.state) {
      toast.error("State is required");
      return false;
    }
    return true;
  };
  const getProfile = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/UserInfo`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const imageUrl = data?.Image?.split('"');
        if (imageUrl) {
          const winnerImageUrl = `${Apiurl()}/${imageUrl?.[1]}`;
          setImageUrl(winnerImageUrl);
          setImageUrlHeader(winnerImageUrl);
        }

        setProfileData(parseData(e?.data?.result));
        setFormData({
          name: data?.Name,
          email: data?.Email,
          address: data?.Address ? data?.Address : "",
          phoneNo: data?.PhoneNumber ? data?.PhoneNumber : "",
          businessName: data?.BusinessName,
          gstno: data?.BusinessGstnumber,
        });
      })
      .catch((error) => {});
  };
  const getBannerImageData = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Banner/GetAccordingToVendor`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setBannerImageData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const Businessvalidations = () => {
    const gstRegex = /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (businessDetail.BusinessName === "") {
      toast.error("Enter Business Name");
      return false;
    }
    if (!businessDetail.BusinessGSTNo ) {
      toast.error("Enter Business GST No");
      return false;
    }
    
    if (!gstRegex.test(businessDetail.BusinessGSTNo)) {
      toast.error("Invalid GST Number. Please enter a valid 15-character GSTIN.");
      return false;
    }
    if (!image) {
      toast.error("Please upload Business Image");
      return false;
    }
    return true;
  };
  const handleMoveToBusiness = (e) => {
    if (!Businessvalidations()) return;
    setLoading("business");
    const data = {
      BusinessName: `${
        e === "UploadNew"
          ? profileData?.BusinessName
          : businessDetail?.BusinessName
      }`,
      BusinessGstnumber: `${
        e === "UploadNew"
          ? profileData?.BusinessGSTNo
          : businessDetail?.BusinessGSTNo
      }`,
      RequestSubmited: true,
      IsActive: true,
      // CompanyImage: businessDetail?.BusinessImage?.split(",")?.[1],
      CompanyImage: croppedImage,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/CustomerBusinessRequest`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          setLoading("");
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        document.getElementById("image-upload-cover").value = "";

        setImage();
        setBusinessDetail({
          BusinessName: "",
          BusinessGSTNo: "",
          BusinessImage: "",
        });
      })
      .catch((error) => {});
  };
  const handleAddAddress = () => {
    if (!validateAddress()) return;
    const data = {};
    if (PrefiledData) {
      data.Id = PrefiledData.Id;
    }
    if (PrefiledData?.IsDefault == true) {
      data.IsDefault = true;
    }
    data.phoneNumber = Address.mobile;
    data.pincode = Address.pincode;
    data.locality = Address.locality;
    data.areaAndStreet = Address.address;
    data.city = Address.city;
    data.state = Address.state;
    data.landmark = Address.landmark;
    data.altPhoneNumber = Address.altPhone;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/AddUpdateDeliveryAddress`,
    };

    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e.data.message);
          getDeliveryAddress();
          setAddress({
            name: "",
            mobile: "",
            pincode: "",
            address: "",
            locality: "",
            city: "",
            state: "",
            landmark: "",
            altPhone: "",
          });
          setShow(false);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const getDeliveryAddress = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/FetchDeliveryAddressList`,
    };
    axios(option)
      .then((e) => {
        setDeliveryAddressList(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const GetBanner = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Vendor/BannerAnalytics`,
    };
    axios(option)
      .then((e) => {
        setBannerData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const GetBannerData = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Banner/GetAccordingToVendor`,
    };
    axios(option)
      .then((e) => {
        setBannerDataImage(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetBanner();
    GetBannerData();
    getProfile();
    getBannerImageData();
    getDeliveryAddress();
  }, []);
  const handleRemoveDeliveryAddress = (addressItem) => {
    const data = {};
    data.id = addressItem.Id;
    data.phoneNumber = addressItem.PhoneNumber ? addressItem.PhoneNumber : "";
    data.pincode = addressItem.Pincode ? addressItem.Pincode : "";
    data.locality = addressItem.Locality ? addressItem.Locality : "";
    data.AreaAndStreet = Address.address ? Address.address : "";
    data.city = addressItem.City ? addressItem.City : "";
    data.state = addressItem.State ? addressItem.State : "";
    data.landmark = addressItem.Landmark ? addressItem.Landmark : "";
    data.altPhoneNumber = addressItem.AltPhoneNumber
      ? addressItem.AltPhoneNumber
      : "";
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/RemoveDeliveryAddress`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          getDeliveryAddress();
          setShow(false);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const handleEditaddress = (addressItem) => {
    setShow(true);
    setPrefiledData(addressItem);
  };
  useEffect(() => {
    if (PrefiledData) {
      setAddress((prevdata) => ({
        ...prevdata,
        mobile: PrefiledData?.PhoneNumber,
        pincode: PrefiledData?.Pincode,
        locality: PrefiledData?.Locality,
        city: PrefiledData?.City,
        state: PrefiledData?.State,
        landmark: PrefiledData?.Landmark,
        altPhone: PrefiledData?.AltPhoneNumber,
        address: PrefiledData?.AreaAndStreet,
      }));
    }
  }, [PrefiledData]);
  const UpdateDefaultDeliveryAddress = (addressItem) => {
    const data = {};
    data.id = addressItem.Id;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/UpdateDefaultDeliveryAddress`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          getDeliveryAddress();
          setShow(false);
        }
      })
      .catch((error) => {});
  };
  const UpdateUserProfile = () => {
    setLoading("updateImage");
    const data = {};
    data.Image = profileImage.replace(/^data:image\/\w+;base64,/, "");
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/UpdateUserProfile`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          setLoading("");
          setProfileChange(true);
          setProfileImage();

          getProfile();
          if (profileImageRed.current) {
            profileImageRed.current.value = "";
          }

          toast.success(e?.data?.message);
        }

        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const handleEditProfile = (e) => {
    setLoading("updateprofile");
    const data = {};
    data.Name = formData.name;
    data.Email = formData.email;
    // data.Address = formData.address;
    data.PhoneNumber = formData.phoneNo !== "" ? formData.phoneNo : null;
    data.BusinessName = formData.businessName;
    data.BusinessGstnumber = formData.gstno;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/Update`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          setLoading("");
          setEditData(false);
          setProfileChange(true);
          getProfile();

          toast.success(e?.data?.message);
        }

        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const handleBannerCancel = () => {
    if (fileBannerRef.current) {
      fileBannerRef.current.value = ""; // Reset the file input field
    }
  };
  // Add New Banner
  const BannerAdd = () => {
    setLoading("bannerAdd");
    const data = {};
    data.BannerUrl = croppedImage;
    data.OfferDescription = "test";
    data.IsPublish = true;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Banner/Add`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          setLoading("");

          getBannerImageData();
          handleBannerCancel();
          setImage();
          toast.success(e?.data?.message);
        }

        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setPreviewImage();
      })
      .catch((error) => {});
  };

  const handleUpdateBannerImage = () => {
    if(!bannerUpdate){
      toast.error("Please upload banner")
      return;
    }
    setLoading("bannerUpdate");
    const data = {};
    data.Id = clickedBannerData?.Id;
    data.BannerUrl = bannerUpdateImage;
    data.OfferDescription = "test";
    data.IsPublish = true;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Banner/Update`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          setLoading("");

          getBannerImageData();
          handleBannerCancel();
          handleCloseBanner();
          setBannerUpdate();
          toast.success(e?.data?.message);
        }

        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header
        profileData={profileData}
        imageUrlHeader={imageUrlHeader}
        setLoginToken={setLoginToken}
      />
      <ProfileComponent
        setProfileImage={setProfileImage}
        FetchGoogleImage={FetchGoogleImage}
        formData={formData}
        profileImage={profileImage}
        setFormData={setFormData}
        setProfileChange={setProfileChange}
        profileChange={profileChange}
        loading={loading}
        profileImageRed={profileImageRed}
        profileData={profileData}
        setEditData={setEditData}
        editData={editData}
        fileBannerRef={fileBannerRef}
        setBuisnessCheck={setBuisnessCheck}
        buisnessCheck={buisnessCheck}
        setBusinessDetail={setBusinessDetail}
        businessDetail={businessDetail}
        handleMoveToBusiness={handleMoveToBusiness}
        UpdateUserProfile={UpdateUserProfile}
        vendorBannerAnalytic={vendorBannerAnalytic}
        setBannerUrl={setBannerUrl}
        setShowSaveButton={setShowSaveButton}
        showSaveButton={showSaveButton}
        setUpdateIndex={setUpdateIndex}
        updateIndex={updateIndex}
        setHideButton={setHideButton}
        hideButton={hideButton}
        setPreviewImage={setPreviewImage}
        previewImage={previewImage}
        Address={Address}
        setAddress={setAddress}
        handleAddAddress={handleAddAddress}
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        handleCloseBanner={handleCloseBanner}
        DeliveryAddressList={DeliveryAddressList}
        handleRemoveDeliveryAddress={handleRemoveDeliveryAddress}
        handleEditaddress={handleEditaddress}
        PrefiledData={PrefiledData}
        UpdateDefaultDeliveryAddress={UpdateDefaultDeliveryAddress}
        handleEditProfile={handleEditProfile}
        setCroppedImage={setCroppedImage}
        setBannerUpdateImage={setBannerUpdateImage}
        BannerAdd={BannerAdd}
        BannerData={BannerData}
        bannerImageData={bannerImageData}
        setImage={setImage}
        setBannerUpdate={setBannerUpdate}
        bannerUpdate={bannerUpdate}
        image={image}
        setShowUpdate={setShowUpdate}
        showUpdate={showUpdate}
        imageUrl={imageUrl}
        clickedBannerData={clickedBannerData}
        setClickedBannerData={setClickedBannerData}
        handleUpdateBannerImage={handleUpdateBannerImage}
      />
      {/* <Croper/> */}
      <Footer />
    </div>
  );
};
export default Profile;
